module.exports = __webpack_public_path__ + "img/yellow-graph.d414aade.png";